// extracted by mini-css-extract-plugin
export default {"cbody":"sign_cbody__8rFGy","box":"sign_box__A6sF+","cimg":"sign_cimg__bHuVC"};